import { DtoEntity } from '../../../types/DtoEntity';
import { ReviewQuestionnaire } from '../../../types/ReviewQuestionnaire';
import * as Req from '../request';

create.operation = 'CREATE';
create.invalidates = ['list'];
export function create(entity: ReviewQuestionnaire) {
    return Req.post<DtoEntity<ReviewQuestionnaire>>(`/api/v2/review-questionnaire`, { postData: entity });
}

get.operation = 'READ';
export function get(id: string) {
    return Req.get<DtoEntity<ReviewQuestionnaire>>(`/api/v2/review-questionnaire/${id}`);
}

list.operation = 'READ';
export function list(includeArchived = false) {
    return Req.get<DtoEntity<ReviewQuestionnaire>[]>(`/api/v2/review-questionnaire`, { getData: { includeArchived } });
}

update.operation = 'UPDATE';
export function update(dtoEntity: DtoEntity<ReviewQuestionnaire>) {
    return Req.put<DtoEntity<ReviewQuestionnaire>>(`/api/v2/review-questionnaire/${dtoEntity.id}`, {
        postData: dtoEntity.value,
    });
}

remove.operation = 'DELETE';
export function remove(id: string) {
    return Req.remove(`/api/v2/review-questionnaire/${id}`);
}
